import { type FC, useContext } from "react";

import { Link, Text } from "@alpacahq/ui/old";

import { useGetClientLogo } from "~/v2/api/hooks";
import { client } from "../../../v2/pages";
import { DEFAULT_LOGO_HASH, getHashFromBlob } from "./AppCard";
import { AppDetailsContext } from "./AppDetailsPage";

export const AppDetailsHeader: FC = () => {
  const {
    client: { name, url, client_id },
  } = useContext(AppDetailsContext);

  const { logo } = useGetClientLogo({
    clientId: client_id,
    options: { enabled: !!client },
  });

  const isDefaultLogo = getHashFromBlob(logo) === DEFAULT_LOGO_HASH;

  return (
    <div className="flex items-start space-x-6">
      {logo && !isDefaultLogo ? (
        <img
          className="h-24 w-24 shrink-0 rounded-md"
          src={logo}
          alt={`${name} logo`}
        />
      ) : (
        <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-md bg-cool-gray-200 font-medium text-2xl text-cool-gray-500">
          {name.charAt(0).toUpperCase()}
        </div>
      )}
      <div className="flex h-full flex-col justify-between">
        <Text className="mb-2 truncate font-semibold text-2xl">{name}</Text>
        <div className="w-64 truncate">
          <Link
            className="font-medium text-lg text-violet-500"
            onClick={() => window.open(url, "_blank")}
          >
            {url}
          </Link>
        </div>
      </div>
    </div>
  );
};
